import { render, staticRenderFns } from "./InstagramMain.vue?vue&type=template&id=3e78094e&scoped=true"
import script from "./InstagramMain.vue?vue&type=script&lang=ts"
export * from "./InstagramMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e78094e",
  null
  
)

export default component.exports